import styled from '@emotion/styled/macro';
import vars from '@variables';

export const SocialLinksWrapper = styled.ul`
  list-style: none;
  display: flex;
  background-color: ${vars.coreDarkGrey};
  padding: ${vars.spacingM};
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;

  ::before {
    content: '';
    flex: 1;
  }

  > * {
    flex: 1;
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    display: none;
  }
`;
